<template>
  <div class="tw-mb-5">
    <WdsHeading as="h1" type="display">{{ $t('Compliance tracker') }}</WdsHeading>
  </div>

  <WdsTabs :active-tab-key="activeTab" @update:active-tab-key="setTab">
    <WdsTab :title="$t('Workers')" tab-key="workers" />
    <WdsTab :title="$t('Staffing agencies')" tab-key="suppliers" />
  </WdsTabs>

  <WorkerComplianceTable v-if="activeTab === 'workers'" />
  <RecruiterComplianceTable v-else-if="activeTab === 'suppliers'" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { WdsHeading, WdsTab, WdsTabs } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import WorkerComplianceTable from '@/components/compliances/WorkerComplianceTable.vue'
import RecruiterComplianceTable from '@/components/compliances/RecruiterComplianceTable.vue'

const route = useRoute()
const router = useRouter()

const activeTab = computed(() => {
  const tab = `${route.query.tab ?? ''}`
  return ['workers', 'suppliers'].includes(tab) ? tab : 'workers'
})

function setTab(next: string) {
  router.replace({ query: { tab: next } })
}
</script>
